import { C, FONTS } from '../../tokens/design';

export default function KevBadge() {
  return (
    <span
      title="Known Exploited Vulnerability — listed in CISA catalog"
      style={{
        display: 'inline-flex', alignItems: 'center',
        padding: '2px 8px', borderRadius: 9999,
        fontSize: 11, fontWeight: 700, letterSpacing: '0.06em',
        fontFamily: FONTS.mono,
        color: C.amb,
        background: C.s3,
        border: `1px solid ${C.amb}66`,
      }}
    >KEV</span>
  );
}
